import { combineReducers } from 'redux';

import topology from './topology';

export default combineReducers({
  topology,
});
